import React, { useState, useRef, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import CommonUtil from "../util/CommonUtils";

function TruncatedTitle({ title,  color  }) {
  const [isTruncated, setIsTruncated] = useState(false);
  const titleRef = useRef(null);

  useEffect(() => {
    const checkIfTruncated = () => {
      if (titleRef.current) {
        // Check if the content overflows by comparing scrollWidth and clientWidth
        setIsTruncated(titleRef.current.scrollWidth > titleRef.current.clientWidth);
      }
    };

    // Initial check if the text is truncated
    checkIfTruncated();

    // Listen for resize events to check if the width changes
    const resizeObserver = new ResizeObserver(checkIfTruncated);
    if (titleRef.current) {
      resizeObserver.observe(titleRef.current);
    }

    // Clean up ResizeObserver on component unmount
    return () => {
      if (titleRef.current) {
        resizeObserver.unobserve(titleRef.current);
      }
    };
  }, [title]);

  return (
    <Tooltip
      title={isTruncated ? title : ""}
      placement="top"
      // arrow
      PopperProps={{
        modifiers: [
          {
            name: "preventOverflow",
            options: {
              boundary: "clippingParents",
            },
          },
          {
            name: "offset",
            options: {
              offset: [15, 8],
            },
          },
        ],
      }}
    >
      <Typography
        ref={titleRef}
        id="timesheet-worklog-copy"
        variant="worklog_project_title"
        sx={{
          wordBreak: "break-word",
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
          display: "inline-block", 
          width: "93%", 
          color: color,
          paddingTop: CommonUtil.getOS() === "MacOS" ? "5px" : "0px"
        }}
      >
        {title}
      </Typography>
    </Tooltip>
  );
}

export default TruncatedTitle;
